import Link from 'next/link'
import React from 'react'

export const MyLink: React.FC<{
  children: React.ReactNode
  href: string
  // 是否已在当前站点上存在
  exist?: boolean
  className?: string
  style?: React.CSSProperties
  host?: string
}> = ({ children, className, href, exist = false, style, host }) => {
  return exist ? (
    <Link href={href} className={className} style={style}>
      {children}
    </Link>
  ) : (
    <a
      href={(host || process.env.NEXT_PUBLIC_WUJIEBANTU_HOST) + href}
      target="_blank"
      rel="noreferrer"
      className={className}
      style={style}
    >
      {children}
    </a>
  )
}
